<template>
  <v-tooltip bottom>
    <span>Opções</span>
    <v-menu bottom left slot="activator">
      <v-btn flat icon small slot="activator">
        <v-icon>more_vert</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile
          v-for="item of items"
          :key="item[itemKey]"
          @click='$emit(item[itemAction])'
        >
          <v-list-tile-title>
            <v-icon v-if="item.icon" small left>{{ item.icon }}</v-icon>{{ item[itemText] }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-tooltip>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    itemKey: {
      type: String,
      default: 'id'
    },
    itemText: {
      type: String,
      default: 'descricao'
    },
    itemAction: {
      type: String
    }
  }
}
</script>

<style>

</style>